import './App.css';
import Header from './Components/Header/Header.js';
import Extra from './Components/Extra/Extra.js';
import Companies from './Components/Companies/Companies.js';
import Residencies from './Components/Residencies/Residencies.js';
import Value from './Components/Value/Value.js';
import Contact from './Components/Contact/Contact.js';
import GetStarted from './Components/GetStarted/GetStarted.js';
import Footer from './Components/Footer/Footer.js';

function App() {
  return (
    <div className="App">
      <Header />
      <Extra />
      <Companies />
      <Residencies />
      <Value />
      <Contact />
      <GetStarted />
      <Footer/>
    </div>
  );
}

export default App;
